<template>
  <div class="container">
    <v-layout wrap>
      <v-flex xs6 class="col s6">
        <h3 class="headline">{{ $t('Admin/Bot Handover') }}</h3>
      </v-flex>

      <v-flex xs6 class="col s6 text-xs-right">
        <v-btn
          v-if="!isEditCommand"
          icon
          outline
          color="primary"
          style="margin-top: 5px; margin-bottom: 5px"
          @click="editCommand"
        >
          <v-icon> edit </v-icon>
        </v-btn>
      </v-flex>
    </v-layout>
    <div class="row">
      <div class="col s5">
        <div class="caption" style="margin-top: 10px">{{ $t('Shortcut to pause a bot') }}</div>
        <div class="form-control" :class="{ 'has-error': errors.has('changestatetoadmin') }">
          <input
            v-if="isEditCommand"
            v-model="hotkey.changestatetoadmin"
            v-validate="'required'"
            name="changestatetoadmin"
            small
            type="text"
          />
          <div v-else class="primary--text">{{ hotkey.changestatetoadmin }}</div>
          <span v-if="errors.has('changestatetoadmin')" class="text-error">{{
            errors.first('changestatetoadmin')
          }}</span>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col s5">
        <div class="caption" style="margin-top: 10px">{{ $t('Shortcut to continue a bot') }}</div>
        <div class="form-control" :class="{ 'has-error': errors.has('changestatetobot') }">
          <input
            v-if="isEditCommand"
            v-model="hotkey.changestatetobot"
            v-validate="'required'"
            name="changestatetobot"
            small
            type="text"
          />
          <div v-else class="primary--text">{{ hotkey.changestatetobot }}</div>
          <span v-if="errors.has('changestatetobot')" class="text-error">{{
            errors.first('changestatetobot')
          }}</span>
        </div>
      </div>
    </div>

    <div class="row">
      <div style="text-align: center" class="col s12">
        <div v-if="isEditCommand">
          <v-btn color="grey" :disabled="loading" outline @click="cancel">{{ $t('cancel') }}</v-btn>
          <v-btn color="primary" :loading="loading" depressed @click="changeBotState">{{
            $t('Save')
          }}</v-btn>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import api from '@/api'

export default {
  data() {
    return {
      hotkey: {
        changestatetoadmin: '',
        changestatetobot: ''
      },
      loading: false,
      cache: '',
      isEditCommand: false
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot',
      setting: 'setting'
    })
  },
  mounted() {
    if (this.setting && this.setting.change_state_to_admin) {
      this.hotkey.changestatetoadmin = this.setting.change_state_to_admin.contentvalue
    }
    if (this.setting && this.setting.change_state_to_bot) {
      this.hotkey.changestatetobot = this.setting.change_state_to_bot.contentvalue
    }
  },
  methods: {
    cancel() {
      this.isEditCommand = false
      this.hotkey = JSON.parse(this.cache)
    },
    editCommand() {
      this.isEditCommand = true
      this.cache = JSON.stringify(this.hotkey)
    },
    changeBotState(type) {
      let vm = this
      this.loading = true
      let obj = {
        pageid: this.selectedBot.pageid,
        input: {
          changestatetoadmin: this.hotkey.changestatetoadmin,
          changestatetobot: this.hotkey.changestatetobot
        }
      }

      api.putchangebotstate(obj, function (error, response) {
        if (error) {
          console.error(error)
          return
        }
        vm.isEditCommand = false
        vm.loading = false
      })
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/billing/adminHandOver.vue